package uk.co.nickthecoder.kyd.events

import uk.co.nickthecoder.kyd.util.Vector2
import uk.co.nickthecoder.glok.event.MouseEvent as GlokMouseEvent

class MouseEvent internal constructor(

    private val glok: GlokMouseEvent,
    val world: Vector2

) {

    internal var captured = false

    var local: Vector2 = Vector2.ZERO
        internal set

    val buttonIndex get() = glok.buttonIndex

    val clickCount get() = glok.clickCount

    val isPrimary get() = glok.isPrimary

    val isSecondary get() = glok.isSecondary

    val isMiddle get() = glok.isMiddle

    val isShiftDown get() = glok.isShiftDown
    val isControlDown get() = glok.isControlDown
    val isAltDown get() = glok.isAltDown
    val isMetaDown get() = glok.isSuperDown

    fun capture() {
        captured = true
    }

}
